/**
 * routerLinks contains the title, path and component name of each page.
 */
export const routerLinks = [
    { title: 'Digital Livestock', path: '/digital-livestock', component: 'DigitalLivestock' },
    {
        title: 'Digital Livestock Consignment',
        path: '/digital-livestock-consignment',
        component: 'DigitalLivestockConsignment',
    },
    {
        title: ' National Vendor Declaration',
        path: '/national-vendor-declaration',
        component: 'NationalVendorDeclaration',
    },
    { title: 'Sell Cattle', path: '/sell-cattle', component: 'SellCattle' },
];
